import { Elm } from './src/ttballs.elm'

Elm.Main.init({
  node: document.querySelector('main')
})